<div class="page-layout blank flex flex-col">
    <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
        <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-col justify-center items-start">
            <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
        </div>
    </div>
    <particle-workflow-wizard [workflowId]="workflowId"
                              [apiEndpointKey]="apiEndpointKey"
                              (GridCellValueChanged)="onGridCellValueChange($event)">

    </particle-workflow-wizard>
</div>

